import React, { ReactElement } from 'react'

export const ConferencedIcon = (): ReactElement => (
    <svg viewBox='0 0 100 100'>
        <path d='m78.418 81.332c-9.75-4.668-16.668-13-20.168-22.582-1.418-3.5-2.25-7.5-2.582-10.918v-6.082h18.75c1.418 0 2.418-1.582 1.418-3.168l-24.668-29.5c-0.83203-1.082-2.75-1.082-3.5 0l-23.918 29.5c-0.83203 1.082 0 3.168 1.418 3.168h18.918v6.082c-0.5 3.668-1.418 7.668-2.582 10.918-3.5 9.582-10.418 17.918-20.168 22.582-1.418 0.5-1.918 2.25-1.418 3.5l2.25 5.418c0.66797 1.418 2.25 1.918 3.668 1.082 10.418-5 18.75-13 23.75-22.582 5.25 9.582 13.332 17.5 24 22.582 1.418 0.66797 3.168 0.5 3.668-1.082l2.25-5.418c0.99609-1.25 0.32812-2.832-1.0859-3.5z' />
    </svg>
)
